export default __webpack_public_path__ + "static/media/137sssasset_4.8d94c0d9.png";